import styled from 'styled-components';
import { useCallback } from 'react';
import { usePositionFiltersModalActions } from '@paradigm/features/src/positions/contexts/filters/modal';
import { usePositionFiltersView } from '@paradigm/features/src/positions/contexts/filters/store';
import BaseFilterButton from '#/components/FilterButton';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { blackPearl } from '@paradigm/design-system/src/colors';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function PositionFiltersButton() {
  const { open } = usePositionFiltersModalActions();
  const { activeFiltersCount } = usePositionFiltersView();
  const trackAction = useTrackAction();
  const handleClick = useCallback(() => {
    trackAction('view filters');
    open();
  }, [open, trackAction]);

  return (
    <Container>
      <FilterButton
        onClick={handleClick}
        activeFiltersCount={activeFiltersCount}
        ariaLabel="position filters button"
        small
      />
    </Container>
  );
}

const Container = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    align-content: end;
    padding: 0.5rem 1rem;
    width: min-content;
    justify-self: end;
  }
`;

const FilterButton = styled(BaseFilterButton)`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    border: 2px solid ${blackPearl};
    height: 28px;
    width: 88px;
  }
`;
